import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select"; // sesuaikan dengan import library kamu

import { cn, getInitials } from '@/lib/utils';


const defaultStatuses = [
  { name: "To Do", group: "Not Started", color: "#9FB0AC", order: 0 },
  { name: "In Progress", group: "Active", color: "#6EC1E4", order: 0 },
  { name: "Review", group: "Review", color: "#F5C26B", order: 0 },
  { name: "Done", group: "Done", color: "#7ED957", order: 0 },
];

const FieldStatus = ({ statuses = [], status, setStatus, selectedAsChip=false, className, ...props }) => {
  const options = statuses.length > 0 ? statuses : defaultStatuses;

  const getStatusColor = (statusName) => {
        const s = statuses.find(st => st.name === statusName);
        return s?.color || '#6B7280';
  };

  // urutkan berdasarkan group dan order
  const groupOrder = ["Not Started", "Active", "Review", "Done"];
  const sortedOptions = [...options].sort((a, b) => {
    const ga = groupOrder.indexOf(a.group);
    const gb = groupOrder.indexOf(b.group);
    if (ga !== gb) return ga - gb;
    return a.order - b.order;
  });

  return (
    <Select value={status} onValueChange={setStatus} {...props}>
      <SelectTrigger className={cn("w-full", className)} onClick={(e) => e.stopPropagation()}>
      { selectedAsChip ? <div className="flex items-center gap-2">
          <p 
              className="px-2 py-0.5 rounded text-xs font-medium text-white"
              style={{ backgroundColor: getStatusColor(status) }}
          >
              {status}
          </p>
      </div> : <SelectValue />}
      </SelectTrigger>
      <SelectContent>
        {sortedOptions.map((s) => (
          <SelectItem key={s.name} value={s.name}>
            <div className="flex items-center gap-2">
              <div
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: s.color }}
              />
              {s.name}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default FieldStatus